<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Reportes</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item active">Reportes</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="btn-group" role="group">
          <v-dropdown
            id="ddown2"
            right
          >
            <button
              id="btnGroupDrop1"
              slot="activator"
              type="button"
              class="btn btn-outline-default dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{columna.text}}
            </button>
            <v-dropdown-item
              v-for="(dato, index) in options"
              :key="index"
              >
              <a class="dropdown-item" @click="changeTypeSearch(dato);">
                {{ dato.text }}
              </a>
            </v-dropdown-item>
          </v-dropdown>
          <!-- <v-dropdown :show-arrow="false" theme-light>
            <button
              id="btnGroupDrop1"
              slot="activator"
              type="button"
              class="btn btn-outline-default dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Seleccione una categoría
            </button>
            <v-dropdown-item >
              <a class="dropdown-item" @click="personal">
                Personal
              </a>
            </v-dropdown-item>
            <v-dropdown-item>
              <a class="dropdown-item" @click="purchases">
                Compras
              </a>
            </v-dropdown-item>
            <v-dropdown-item>
              <a class="dropdown-item" @click="sales">
                Ventas
              </a>
            </v-dropdown-item>
          </v-dropdown> -->
        </div><br>
      </div>
      <div class="card-body">
        <!-- Productos, Personal, compras, ventas, cuentas bodega. dentro del table poner un v-if -->
        <h4 v-if="columna.value=='personal'">Reportes de personal</h4>
        <h4 v-if="columna.value=='compras'">Reportes de compras</h4>
        <h4 v-if="columna.value=='ventas'">Reportes de ventas</h4>
        <!-- Personal -->
        <table v-if="columna.value=='personal'" class="table table-responsive">
          <thead>
            <tr>
              <th>Acciones</th>
              <th>Nombre</th>
              <th>Descripcion del reporte</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('personal', 'especifico1')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte empleado que más vende</td>
              <td>Presenta </td>
            </tr>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('personal', 'especifico1')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte empleado que menos vende</td>
              <td>Presenta </td>
            </tr>
            <!-- <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('personal', 'especifico1')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte empleado especifico</td>
              <td>Presenta la cantidad de faltas y los salarios adelantados pendientes por pagar de un empleado en específico</td>
            </tr>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('personal', 'faltas')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte cantidad de faltas de empleados</td>
              <td>Presenta las faltas cometidas por los empleados</td>
            </tr>

            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('personal', 'salarios')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte de empleados con salarios adelantados</td>
              <td>Presenta a los empleados que tengan salarios adelantados</td>
            </tr>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('personal', 'localidades')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte de empleados por sucursal</td>
              <td>Presenta a los empleados por sucursal</td>
            </tr> -->
          </tbody>
        </table>
        <!-- Compra -->
        <table v-if="columna.value=='compras'" class="table table-responsive">
          <thead>
            <tr>
              <th>Acciones</th>
              <th>Nombre</th>
              <th>Descripcion del reporte</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('compras', 'mensual')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte de compras mensuales</td>
              <td>Presenta el reporte de compras mensuales</td>
            </tr>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('compras', 'especifico')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte de compras específicas, no mayor a 30 días</td>
              <td>Presenta las compras dentro de un rango de fechas</td>
            </tr>
          </tbody>
        </table>
        <!-- Ventas -->
        <table v-if="columna.value=='ventas'" class="table table-responsive">
          <thead>
            <tr>
              <th>Acciones</th>
              <th>Nombre</th>
              <th>Descripcion del reporte</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('ventas', 'mensual')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Reporte con fechas especificas</td>
              <td>Presenta el reporte de ventas con fechas especificas</td>
            </tr>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('ventas', 'especifico')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Producto más vendido</td>
              <td>Presenta los productos más vendidos</td>
            </tr>
            <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('ventas', 'especifico')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Cliente que más compra</td>
              <td>Presenta los clientes que más compran</td>
            </tr>
            <!-- <tr>
              <td>
                <button v-tooltip.top-center="'Generar reporte'" type="button" class="btn btn-primary btn-sm" @click="openModal('ventas', 'especifico')">
                  <i class="icon-fa icon-fa-file-text"/>
                </button> &nbsp;
              </td>
              <td>Producto menos vendido</td>
              <td>Presenta los productos menos vendidos</td>
            </tr> -->
          </tbody>
        </table>
        <!-- Tabla maquetada por Arturo y Pedro-->
      </div>

      <!-- MODALES -->
      <sweet-modal ref="simple_param_modal" :title="titleModal" hide-close-button blocking>
        <!-- START FORM -->
        <div class="card-body">
          <div v-if="picker==true" class="form-group">
            <label>{{ typeModal }}</label>
            <multiselect
              v-model="simple_parameter"
              :options="arraySimpleParameter"
              :close-on-select="true"
              :clear-on-select="false"
              :show-labels="false"
              :preserve-search="true"
              :loading="isLoading"
              placeholder="Seleccione"
              label="name"
              track-by="id"
              @input="$v.simple_parameter.$touch()"
              @search-change="filterSelect"
            />
            <div v-if="$v.simple_parameter.$error">
              <span
                v-if="!$v.simple_parameter.required"
                class="error"
              >El campo es requerido</span>
            </div>
          </div>
          <div v-if="date==true" class="form-group">
            <label>Inicio</label>
            <datepicker
              :bootstrap-styling="true"
              :format="customFormatter"
              :language="es"
              v-model="dateinit"
              placeholder="Seleccione fecha"
              @input="$v.dateinit.$touch()"
            />
            <div v-if="$v.dateinit.$error">
              <span
                v-if="!$v.dateinit.required"
                class="error"
              >El campo es requerido</span>
            </div>
            <br>
            <label>Final</label>
            <datepicker
              :bootstrap-styling="true"
              :format="customFormatter"
              :language="es"
              v-model="dateend"
              placeholder="Seleccione fecha"
              @input="$v.dateend.$touch()"
            />
            <div v-if="$v.dateend.$error">
              <span
                v-if="!$v.dateend.required"
                class="error"
              >El campo es requerido</span>
            </div>
          </div>
          <div v-if="datemonth==true" class="form-group">
            <label>Seleccione el mes</label>
            <datepicker
              :bootstrap-styling="true"
              :minimum-view="'month'"
              :maximum-view="'month'"
              :format="customFormatter"
              :language="es"
              v-model="dateinit"
              placeholder="Seleccione fecha"
              @input="$v.dateinit.$touch()"
            />
            <div v-if="$v.dateinit.$error">
              <span
                v-if="!$v.dateinit.required"
                class="error"
              >El campo es requerido</span>
            </div>
          </div>
        </div>
        <!-- END FORM -->

        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="typeAction == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveSimpleReport()"
        >Generar reporte</button>
      </sweet-modal>

      <sweet-modal ref="employee_modal" :title="titleModal" hide-close-button blocking>
        <div class="card-body">
          <div class="form-group">
            <multiselect
              v-model="simple_parameter"
              :options="arraySimpleParameter"
              :close-on-select="true"
              :clear-on-select="false"
              :show-labels="false"
              placeholder="Seleccione un empleado"
              label="name"
              track-by="id"
            />
          </div>
        </div>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="typeAction == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="openModal('personal', 'especifico2')"
        >Generar reporte</button>
      </sweet-modal>
    </div>

  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, numeric } from 'vuelidate/lib/validators'
import ladda from 'ladda'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Datepicker,
    Multiselect
  },
  data () {
    return {
      en: en,
      es: es,
      // ! Personal
      simple_parameter: null,
      arraySimpleParameter: [],
      titleModal: '',
      typeModal: '',
      checkboxmanual: false,
      id: 0,
      typeAction: 1,
      tituloModalActivar: '',
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0
      },
      offset: 3,
      item: 'name',
      search: '',
      critery: '',
      role: {
        id: 0,
        state: 1,
        name: ''
      },
      isLoading: false,
      table: 1,
      filter: '',
      date: false,
      datemonth: false,
      dateinit: null,
      dateend: null,
      picker: false,
      number: null,
      numberbool: false,
      action: '',
      options: [
        { value: 'personal', text: 'Personal' },
        { value: 'compras', text: 'Compras',  },
        { value: 'ventas', text: 'Ventas',  },
      ],
      columna: { value: 'personal', text: 'Personal' },
    }
  },
  validations () {
    if (this.action == 'employee' || this.action == 'employeefault' ||
     this.action == 'employeesalary' || this.action == 'employeeplace' ||
     this.action == 'custumerfrec' || this.action == 'custumercant' ||
     this.action == 'account') {
      return {
        simple_parameter: {
          required
        },
        number: {
          // required,
          // numeric
        },
        dateinit: {},
        dateend: {}
      }
    } else if (this.action == 'salemonth' || this.action == 'purchasemen') {
      return {
        simple_parameter: {
          required
        },
        number: {
          // required,
          // numeric
        },
        dateinit: {
          required
        },
        dateend: {}
      }
    } else if (this.action == 'saleespe' || this.action == 'purchasespe' ||
    this.action == 'accountdate'
    ) {
      return {
        simple_parameter: {
          required
        },
        number: {
          // required,
          // numeric
        },
        dateinit: {
          required
        },
        dateend: {
          required
        }
      }
    } else if (this.typeModal == 'bodega') {
      return {
        simple_parameter: {
          // required
        },
        number: {
          required,
          numeric
        },
        dateinit: {
          // required
        },
        dateend: {
          // required
        }
      }
    } else if (this.typeModal == 'bodegafecha') {
      return {
        simple_parameter: {
          // required
        },
        number: {
          // required,
          // numeric
        },
        dateinit: {
          required
        },
        dateend: {
          required
        }
      }
    } else {
      return {
        simple_parameter: {
          // required
        },
        number: {
          // required,
          // numeric
        },
        dateinit: {
          // required
        },
        dateend: {
          // required
        }
      }
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + this.offset * 2
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {

  },
  methods: {
    openModal (modelo, accion) {
      switch (modelo) {
        // Aqui ponen sus casos.
        case 'ventas':
        {
          switch (accion) {
            case 'mensual':
            {
              this.selectPlaces('A')
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione sucursal y fechas para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una sucursal'
              this.datemonth = true
              this.picker = true
              this.action = 'salemonth'
              // año  y mes
              // window.open(`/api/reports/ventas/mensual?place=${this.simple_parameter.id}&name=${this.simple_parameter.name}` + '', '_blank')
              break
            }
            case 'especifico':
            {
              this.$refs.simple_param_modal.open()
              this.picker = true
              this.date = true
              this.selectPlaces('A')
              this.titleModal = 'Seleccione sucursal y fechas para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una sucursal'
              this.action = 'saleespe'
              break
            }
          }
          break
        }
        case 'compras':
        {
          switch (accion) {
            case 'mensual':
            {
              this.selectPlaces('A')
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione sucursal y fechas para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una sucursal'
              this.datemonth = true
              this.picker = true
              this.action = 'purchasemen'
              // Aqui descarga directo el reporte pero que hueva hacer otra funcion solo para eso
              // window.open('/api/reports/generalCompras' + '', '_blank')
              break
            }
            case 'especifico':
            {
              this.picker = true
              this.date = true
              this.selectPlaces('A')
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione sucursal y fechas para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una sucursal'
              this.action = 'purchasespe'
              break
            }
          }
          break
        }
        // Aqui ponen sus casos
        case 'personal':
        {
          switch (accion) {
            case 'especifico1':
            {
              this.selectEmployees('A')
              this.picker = true
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione un empleado para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione un empleado'
              this.action = 'employee'
              break
            }
          }
          switch (accion) {
            case 'especifico2':
            {
              window.open(`/api/reports/empleados/especifico?empleado=${this.simple_parameter.id}&nombre=${this.simple_parameter.name}` + '', '_blank')
              break
            }
          }
          switch (accion) {
            case 'faltas':
            {
              this.selectEmployees('A')
              this.picker = true
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione un empleado para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione un empleado'
              this.action = 'employeefault'
              // window.open('/api/reports/empleados/faltas' + '', '_blank')
              break
            }
          }
          switch (accion) {
            case 'salarios':
            {
              this.selectEmployees('A')
              this.picker = true
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione un empleado para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione un empleado'
              this.action = 'employeesalary'

              break
            }
          }
          switch (accion) {
            case 'localidades':
            {
              this.selectPlaces('A')
              this.picker = true
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione una localidad para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una localidad'
              this.action = 'employeeplace'
              break
            }
          }
          switch (accion) {
            case 'cliente1':
            {
              this.selectPlaces('A')
              this.picker = true
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione una localidad para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una localidad'
              this.action = 'custumerfrec'
              // window.open('/api/reports/clientes/frecuecia' + '', '_blank')
              break
            }
          }
          switch (accion) {
            case 'cliente2':
            {
              this.selectPlaces('A')
              this.picker = true
              this.$refs.simple_param_modal.open()
              this.titleModal = 'Seleccione una localidad para generar el reporte'
              this.typeAction = 1
              this.typeModal = 'Seleccione una localidad'
              this.action = 'custumercant'
              // window.open('/api/reports/clientes/cantidad' + '', '_blank')
              break
            }
          }
          break
        }
      }
    },
    saveSimpleReport () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        if (this.action === 'employee') {
          window.open(`/api/reports/empleados/especifico?empleado=${this.simple_parameter.id}&nombre=${this.simple_parameter.name}` + '', '_blank')
        }
        else if (this.action === 'employeefault') {
          window.open(`/api/reports/empleados/faltas?empleado=${this.simple_parameter.id}&nombre=${this.simple_parameter.name}` + '', '_blank')
        }
        else if (this.action === 'employeesalary') {
          window.open(`/api/reports/empleados/salarios?empleado=${this.simple_parameter.id}&nombre=${this.simple_parameter.name}` + '', '_blank')
        }
        else if (this.action === 'employeeplace') {
          window.open(`/api/reports/empleados/localidades?localidad=${this.simple_parameter.id}` + '', '_blank')
        }
        else if (this.action === 'purchasespe') {
          this.dateend.setDate(this.dateend.getDate() + 1)
          window.open(`/api/reports/compras/fechas?place=${this.simple_parameter.id}&name=${this.simple_parameter.name}&init=${this.customFormatter(this.dateinit)}&end=${this.customFormatter(this.dateend)}` + '', '_blank')
        }
        else if (this.action === 'saleespe') {
          window.open(`/api/reports/ventas/fechas/${this.customFormatter(this.dateinit)}/${this.customFormatter(this.dateend)}/${this.simple_parameter.id}` + '', '_blank')
        }
        else if (this.action === 'purchasemen') {
          window.open(`/api/reports/compras/mensual?place=${this.simple_parameter.id}&name=${this.simple_parameter.name}&month=${this.dateinit.getMonth() + 1}&year=${this.dateinit.getFullYear()}` + '', '_blank')
        }
        else if (this.action === 'salemonth') {
          window.open(`/api/reports/ventas/mensual?place=${this.simple_parameter.id}&name=${this.simple_parameter.name}&month=${this.dateinit.getMonth() + 1}&year=${this.dateinit.getFullYear()}` + '', '_blank')
        }
        this.closeModal();
      }
    },
    closeModal () {
      this.$refs.simple_param_modal.close()
      this.$refs.employee_modal.close()
      this.simple_parameter = null
      this.arraySimpleParameter = []
      this.titleModal = ''
      this.typeModal = ''
      this.typeAction = 1
      this.filter = ''
      this.date = false
      this.$v.$reset()
      this.dateinit = ''
      this.dateend = ''
      this.picker = false
      this.numberbool = false
      this.action = ''
      this.datemonth = false
    },
    validarTecla: function (e) {
      if (e.keyCode === 13) {
        if (this.typeAction === 1) {
          this.saveRole()
        } else if (this.typeAction === 2) {
          this.updateRole()
        }
      } else if (e.keyCode === 50) {
        console.log('@ was pressed')
      }
    },
    selectPlaces (filter) {
      let me = this
      this.arraySimpleParameter = []
      var url = `/api/admin/place/select?filter=${filter}`
      this.isLoading = true
      // eslint-disable-next-line no-undef
      axios.get(url).then(function (response) {
        me.arraySimpleParameter = response.data.data
        me.isLoading = false
      })
        .catch(function (error) {
          console.log(error)
          me.isLoading = false
        })
    },
    selectEmployees (filter) {
      let me = this
      this.isLoading = true
      this.arraySimpleParameter = []
      // eslint-disable-next-line no-undef
      axios.get(`/api/admin/employees/getSelect?filter=${filter}`)
        .then(function (response) {
          me.arraySimpleParameter = response.data.data
          // me.$refs.employee_modal.open()
          me.isLoading = false
        })
        .catch(function (error) {
          console.log(error)
          me.isLoading = false
        })
    },
    personal () {
      this.table = 1
    },
    purchases () {
      this.table = 2
    },
    sales () {
      this.table = 3
    },
    selectif () {
      if (this.action === 'employee') {
        this.selectEmployees(this.filter)
      } else if (this.action === 'employeefault') {
        this.selectEmployees(this.filter)
      } else if (this.action === 'employeesalary') {
        this.selectEmployees(this.filter)
      } else if (this.action === 'employeeplace') {
        this.selectPlaces(this.filter)
      } else if (this.action === 'custumerfrec') {
        this.selectPlaces(this.filter)
      } else if (this.action === 'custumercant') {
        this.selectPlaces(this.filter)
      } else if (this.action === 'purchasespe') {
        this.selectPlaces(this.filter)
      } else if (this.action === 'saleespe') {
        this.selectPlaces(this.filter)
      } else if (this.action === 'purchasemen') {
        this.selectPlaces(this.filter)
      } else if (this.action === 'salemonth') {
        this.selectPlaces(this.filter)
      }
    },
    filterSelect (filter) {
      this.filter = filter
      this.selectif()
      // console.log(this.filter)
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    changeTypeSearch (columna) {
      this.columna = columna
    },
  }
}

</script>
<style>
.error {
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/settings/Reports.vue